export const accessConfig = (accessConfigData, navToConfig) => e => {
  var now = new Date().getTime();
  var timeSince = now - accessConfigData.latestTap;
  if (timeSince < 300 && timeSince > 0) {
    accessConfigData.nbTap = accessConfigData.nbTap + 1;
    if (accessConfigData.nbTap === 4) {
      navToConfig();
    }
  } else {
    accessConfigData.nbTap = 1;
  }

  accessConfigData.latestTap = new Date().getTime();
};

export const initialData = {
  latestTap: 0,
  nbTap: 1
};



// WEBPACK FOOTER //
// ./src/services/access-config.js